module.exports = __webpack_public_path__ + "img/featured.4d87825a.png";